export default "__VITE_ASSET__Dcs5gtAQ__"